export const LOAD: string = 'LOAD';
export const RESET: string = 'RESET';
export const ADD: string = 'ADD';
